// useNotificationWithCooldown.js
import { useState, useCallback } from 'react';
import { message } from 'antd';

let notificationTimer = null; // Variable to track notification cooldown
const notificationCooldown = 5000; // 5 seconds cooldown between notifications

const useNotificationWithCooldown = () => {
  // Hook to show notification with cooldown
  const showNotificationWithCooldown = useCallback((description) => {
    if (!notificationTimer) {
      message.error(description);
      notificationTimer = setTimeout(() => {
        notificationTimer = null; // Reset the timer after cooldown
      }, notificationCooldown);
    }
  }, []);

  return showNotificationWithCooldown;
};

export default useNotificationWithCooldown;
